import { nav } from './vi/nav-login-layout-dashboard-keys';
import { common } from './vi/common-panel-tracker-kpi-keys';
import { marketing } from './vi/marketing-ua-report-filter-keys';
import { ecpm } from './vi/ecpm-tracker-filters-admob-mediation-keys';
import { leave } from './vi/leave-request-hr-tabs-working-days-keys';
import { schedule } from './vi/work-schedule-registration-popup-keys';
import { employees } from './vi/employees-profile-salary-ua-permissions-exam-keys';
import { finance } from './vi/finance-products-revenue-cost-arpu-devadj-keys';
import { encrypt } from './vi/encrypt-tool-projects-adunits-keys';
import { localize } from './vi/localize-pipeline-video-jobs-keys';
import { uaBotConsole } from './vi/ua-bot-console-overview-forum-interaction-keys';
import { appSpy } from './vi/app-spy-search-lookup-topcharts-logs-keys';
import { campaignNaming } from './vi/campaign-naming-validator-tab-keys';
import { asoTranslate } from './vi/aso-translate-keys';
import { licenses } from './vi/licenses-admin-keys';
import { firebaseRc } from './vi/firebase-rc-editor-settings-keys';
import { ga4 } from './vi/ga4-event-analytics-keys';
import { connectorTokens } from './vi/connector-tokens-page-keys';
import { siteContent } from './vi/site-content-jobs-blog-publisher-keys';
import { employeeHandbook } from './vi/employee-handbook-keys';
import { examModule } from './vi/exam-module-keys';
import { commissionCore } from './vi/commission-statistics-distribution-iap-my-keys';
import { commissionConfig } from './vi/commission-config-editor-keys';
import { quizAdmin } from './vi/quiz-admin-editor-keys';
import { quizPlayer } from './vi/quiz-player-game-keys';
import { quizHost } from './vi/quiz-host-control-keys';
import { playableTemplates } from './vi/playable-templates-keys';
import { playableEffectSlots } from './vi/playable-effect-slots-keys';
import { playableLayers } from './vi/playable-layers-keys';
import { playableCopy } from './vi/playable-copy-keys';
import { playableSave } from './vi/playable-save-keys';
import { playableElement } from './vi/playable-element-keys';
import { playableExportBatch } from './vi/playable-export-batch-keys';
import { playableVariantsServer } from './vi/playable-variants-server-keys';
import { issues } from './vi/issues-board-list-backlog-keys';
import { gadsEditor } from './vi/gads-campaign-editor-keys';
import { teamBuilding } from './vi/team-building-page-keys';
import { okr } from './vi/okr-keys';
import { game } from './vi/game-keys';
import { navToggles } from './vi/nav-toggles-admin-keys';
import { moLead } from './vi/mo-lead-page-keys';
import { admobBlock } from './vi/admob-block-keys';
import { pageSubtitles } from './vi/page-subtitle-keys';
import { storeMachinesNav } from './vi/store-machines-nav-keys';

export const vi: Record<string, string> = {
  ...nav,
  ...common,
  ...marketing,
  ...ecpm,
  ...leave,
  ...schedule,
  ...employees,
  ...finance,
  ...encrypt,
  ...localize,
  ...uaBotConsole,
  ...appSpy,
  ...campaignNaming,
  ...asoTranslate,
  ...firebaseRc,
  ...ga4,
  ...connectorTokens,
  ...siteContent,
  ...employeeHandbook,
  ...examModule,
  ...commissionCore,
  ...commissionConfig,
  ...quizAdmin,
  ...quizPlayer,
  ...quizHost,
  ...licenses,
  ...playableTemplates,
  ...playableEffectSlots,
  ...playableLayers,
  ...playableCopy,
  ...playableSave,
  ...playableElement,
  ...playableExportBatch,
  ...playableVariantsServer,
  ...issues,
  ...gadsEditor,
  ...teamBuilding,
  ...okr,
  ...game,
  ...navToggles,
  ...moLead,
  ...admobBlock,
  ...pageSubtitles,
  ...storeMachinesNav,
};
